import React, { ReactNode } from 'react';

interface TitleProps {
  size: number;
  children: ReactNode;
  classnames?: string;
}

const Title = ({ size, children, classnames }: TitleProps) => {
  return React.createElement(`h${size}`, { className: classnames }, children);
};

export default Title;
